const MENUBAR_SECTIONS = [
  {
    label: "Insights",
    blocks: [
      {
        label: "Relationship Graph",
        path: "relationship-graph",
      },
      {
        label: "Model Graph",
        path: "model-graph",
      },
      {
        label: "Quality",
        path: "quality",
      },
    ],
  },
  {
    label: "Actions",
    blocks: [
      {
        label: "What-If",
        path: "what-if",
      },
      {
        label: "Predict",
        path: "predict",
      },
    ],
  },
];

export { MENUBAR_SECTIONS };
